// extracted by mini-css-extract-plugin
module.exports = {"arrow-icon-link":"Link_arrow-icon-link__Gj3az","arrow-icon":"Link_arrow-icon__A4RQX"};